/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Refusal_Signed_OutInputs */



/**
* | output |
* | --- |
* | "You're signed out. Sign in again." |
*
* @param {Refusal_Signed_OutInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const refusal_signed_out = /** @type {((inputs?: Refusal_Signed_OutInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refusal_Signed_OutInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вы вышли из аккаунта. Войдите снова.")
	return /** @type {LocalizedString} */ ("You're signed out. Sign in again.")
});